import { Environment, VoomaPageInfo } from './types';

export function matchVooma(url: string): Environment | null {
  if (url.includes('localhost')) return 'development';
  if (url.includes('vooma-clerk-staging')) return 'staging';
  if (url.includes('vooma')) return 'production';
  return null;
}

export function getVoomaPageInfo(environment: Environment): VoomaPageInfo {
  return { pageType: 'vooma', environment };
}
